export default "__VITE_ASSET__c85c9f5f__"